import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard as AuthGuard } from '../authentication/authentication.guard';
import { AddressSearchComponent } from './case-search/case-search.component';
import { CaseListingComponent } from './case/case-listing/case-listing.component';
import { CreateCaseComponent } from './case/create-case/create-case.component';
import { CodeEnforcementSigninFormComponent } from './code-enforcement-signin-form/code-enforcement-signin-form.component';
import { CodeEnforcementComponent } from './code-enforcement.component';

import { ExpiredCaseComponent } from './expired-case/expired-case.component';


const routes: Routes = [
    { path: 'code-sign-in', component: CodeEnforcementSigninFormComponent },
    { path: 'enforcement', component: CodeEnforcementComponent },
    { path: 'search-address', component: AddressSearchComponent },
    { path: 'create-case', component: CreateCaseComponent },
    { path: 'case-listing', component: CaseListingComponent },
    { path: 'expired-case', component: ExpiredCaseComponent },


];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class CodeEnforcementRoutingModule { }
